import PropTypes from 'prop-types';
import React from 'react';
import ReactDocumentTitle from 'react-document-title';

import { translate as t } from '../../lib/I18n';

import AppNotify from './AppNotify';
import PureRenderComponent from '../PureRenderComponent';

class Page extends PureRenderComponent {

    static propTypes = {
        name: PropTypes.string,
        title: PropTypes.string,
        children: PropTypes.any,
        goBack: PropTypes.bool
    };

    static defaultProps = {
        goBack: true,
        name: 'default',
        title: null,
        children: null
    };

    _getTitle ({ title, name }) {
        if (!title) {
            const key = `pageTitles.${name}`;
            const found = t(key);
            title = found !== key ? found : t('pageTitles.default');
        }
        return title;
    }

    render () {
        const { goBack, children } = this.props;
        const title = this._getTitle(this.props);

        return (
            <AppNotify title={ title } goBack={ goBack }>
                <ReactDocumentTitle title={ title }>
                    { children }
                </ReactDocumentTitle>
            </AppNotify>
        );
  }

}

export default Page;



// WEBPACK FOOTER //
// ./src/components/general/Page.js